<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" id="FTC_BTCMT_CRUD_1" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <form name="calculation901ReasonForm" id="calculation901ReasonForm" novalidate autocomplete="off">
    <div class="row">
      <div class="form-group">
        <label class="col-md-1 control-label">
          <strong>Comments:</strong>
        </label>
        <div class="col-md-6">
          <textarea class="form-control" name="comments" id="FTC_BTCMT_CRUD_2"
                    [(ngModel)]="COMMENTS" required maxlength="3998"></textarea>
          <div class="textarea_allowed">Max 4000</div>
        </div>
      </div>
    </div>

    <div class="row row-mt-10">
      <div class="col-md-12">
        <table class="table table-bordered" style="text-align: left; table-layout: fixed;">
          <thead>
            <tr>
              <th width="70%">Comment</th>
              <th width="15%">Logged By</th>
              <th width="15%">Logged On</th>
            </tr>
          </thead>
          <tbody>
            @for (comment of allComments; track $index) {
<tr>
              <td style="word-wrap: break-word">{{comment.COMMENTS}}</td>
              <td>{{comment.LOGGED_BY}}</td>
              <td>{{comment.LOGGED_ON}}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <br>
    </div>

    @if (!ReturnAsFiled) {
<div class="modal-footer">
      <button id="FTC_BTCMT_CRUD_3" class="btn btn-info btn-sm" type="button" 
              (click)="save()" [disabled]="isSaveClicked">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
      <button id="FTC_BTCMT_CRUD_4" class="btn btn-warning btn-sm" type="button"
              (click)="cancel()">Cancel</button>
    </div>
}
  </form>
</div>

